import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const PMStatus = ({ type = 'info', children, className = '', ...props }) => {
  const getStatusStyles = (statusType) => {
    // First check if this is a states type with specific state value
    
    switch (statusType) {
      case 'on_track':
        return 'bg-emerald-500 text-white'; // Green = Positive Progress
      case 'delayed':
        return 'bg-amber-500 text-white'; // Amber = Warning/Delay
      case 'completed':
        return 'bg-blue-500 text-white'; // Teal = Finished / Done
      case 'blocked':
        return 'bg-rose-600 text-white'; // Rose = Blocked/Error
      case 'unassigned':
        return 'bg-slate-500 text-white'; // Slate = Neutral/Unassigned
      case 'cache_in_progress':
        return 'bg-purple-600 text-white'; // Purple = System Process/Cache
      case 'running':
        return 'bg-orange-500 text-white'; // Orange = Actively Running
      case 'delayed_critical':
        return 'bg-red-700 text-white'; // Red = Critical/Error
      case 'unallocated':
        return 'bg-zinc-400 text-white'; // Zinc = Unallocated Resource
      case 'waiting':
        return 'bg-pink-400 text-white'; // Pink = Passive Waiting
      case 'not_started':
        return 'bg-lime-400 text-black'; // Lime = Fresh/Not Started
      default:
        return 'bg-gray-400 text-white'; // Default fallback for states
    }
    
    
    // Original status types
    // switch (statusType) {
    //   case 'success':
    //     return 'bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-300 border-green-200 dark:border-green-700';
    //   case 'warning':
    //     return 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-700';
    //   case 'error':
    //     return 'bg-red-100 dark:bg-red-900/20 text-red-800 dark:text-red-300 border-red-200 dark:border-red-700';
    //   case 'highlight':
    //     return 'bg-yellow-500 text-white';
    //   case 'info':
    //   default:
    //     return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 border-gray-300 dark:border-gray-600';
    // }
  };

  // Get the actual status value to use
  const statusValue = type;

  // Process children to handle markdown content
  const processedChildren = typeof children === 'string' ? (
    <ReactMarkdown 
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        // Prevent paragraph tags from breaking the inline styling
        p: ({children}) => <>{children}</>,
        mark: ({ children, ...props }) => (
          <mark className="bg-yellow-200 dark:bg-yellow-800 px-1 rounded text-gray-900 dark:text-gray-100" {...props}>
            {children}
          </mark>
        )
      }}
    >
      {children}
    </ReactMarkdown>
  ) : children;

  // For info type, render as normal text without badge styling
  // if (type === 'info') {
  //   return (
  //     <span className={`pm-status-info text-gray-700 dark:text-gray-300 ${className}`} {...props}>
  //       {processedChildren}
  //     </span>
  //   );
  // }
  
  // For states type or other types, render with badge styling
  return (
    <span 
      className={`pm-status inline-flex items-center px-2 py-1 text-xs font-medium rounded-md ${type === 'states' ? '' : 'border'} ${getStatusStyles(statusValue)} ${className}`}
      {...props}
    >
      {processedChildren}
    </span>
  );
};

export default PMStatus; 